import React, { useState, useEffect } from "react";
import PokemonImage from "./PokemonImage";
import ButtonRectangle from "./ButtonRectangle";

import { DetailsMesures } from "./DetailsMesures";
import { Ranking } from "./Ranking";
import usePokemonData from "../utils/usePokemonData";
import Stats from "./Stats";
import { IconQuestionMark, IconX } from "@tabler/icons-react";
import useEvolutionChain from "../utils/useEvolutionChain";
import usePokemons from "../utils/usePokemons";
import { useMediaQuery } from "react-responsive";
import Thumbnail from "./Thumbnail";
export const FichaTecnicaTableta = ({ mainDetailsURL, idMain }) => {
  const [isModalOpenCardDetails, setIsModalOpenCardDetails] = useState(true);
  const isTablet = useMediaQuery({ minWidth: 780, maxWidth: 1023 });
  const secondary = mainDetailsURL?.species?.url;
  const detailsSecondaryURL = usePokemonData(secondary);
  const colorOutcome = "red";
  // const [evolutions, setEvolutions] = useState([]);
  const nameEvolutions = mainDetailsURL?.name;
  const messageEvolution = "No further evolution";
  const { evolutionData, loading, error } = useEvolutionChain(nameEvolutions);
  const basePokemon = evolutionData?.chain?.species?.name || messageEvolution;
  const firstEvol = evolutionData?.chain?.species?.name || messageEvolution;
  const secondEvol =
    evolutionData?.chain?.evolves_to[0]?.species?.name || messageEvolution;

  const thirdEvolution =
    evolutionData?.chain?.evolves_to?.[0]?.evolves_to?.[0]?.species?.name ||
    messageEvolution;
  const [totalStats, setTotalStats] = useState(0);
  const { pokemonsUtils: allPokemonsToEvolutions, isLoading } = usePokemons();
  useEffect(() => {
    if (mainDetailsURL?.stats) {
      // Usamos reduce para sumar todos los base_stat
      const total = mainDetailsURL.stats.reduce(
        (sum, stat) => sum + stat.base_stat,
        0
      );
      setTotalStats(total);
    }
  }, [mainDetailsURL]); // Se ejecuta cuando mainDetailsURL cambia

  const toggleModalCloseOpen = () => {
    if (isTablet) setIsModalOpenCardDetails(!isModalOpenCardDetails);
  };

  const filterBase = basePokemon
    ? allPokemonsToEvolutions?.filter((pokemon) =>
        pokemon.name.includes(basePokemon.toLowerCase())
      )
    : "no pokemon found";
  const filterFrstEv = firstEvol
    ? allPokemonsToEvolutions?.filter((pokemon) =>
        pokemon.name.includes(firstEvol.toLowerCase())
      )
    : "no pokemon";
  const filterSndEvol = secondEvol
    ? allPokemonsToEvolutions?.filter((pokemon) =>
        pokemon.name.includes(secondEvol?.toLowerCase())
      )
    : "no pokemon";

  const pokemonDataAccesImagen = usePokemonData(filterBase[0]?.url);
  const imageBase =
    pokemonDataAccesImagen?.sprites?.versions?.["generation-v"]?.["black-white"]
      ?.front_default;
  const titleBase = pokemonDataAccesImagen?.name;
  if (!imageBase) {
    return;
  } else {
    console.log(imageBase);
  }
  /* A esta url es a la que se hace fetch para acceder a resultadoFetch.sprites.front_shiny, es la imagen */

  return (
    <>
      {isModalOpenCardDetails && isTablet && (
        <div className="overlay-card">
          <button onClick={toggleModalCloseOpen} className="x-overly">
            <IconX />
          </button>
          <div className="container-ficha-tecnica">
            {/* tabler icon */}
            <section className="columna-uno">
              <div className="img-pokemon-container">
                <PokemonImage
                  src={
                    mainDetailsURL?.sprites?.versions?.["generation-v"]?.[
                      "black-white"
                    ]?.["animated"]?.front_default || "fallback-image.png"
                  }
                  alt="pokemon selected"
                />
              </div>
              <div id="stats">
                <h4 style={{ margin: "0 0 1rem" }}>Stats</h4>
                <div className="rendered-stats">
                  {mainDetailsURL?.stats ? (
                    mainDetailsURL?.stats?.map((stat, index) => {
                      return (
                        <Stats
                          key={index}
                          name={stat.stat.name}
                          base={stat.base_stat}
                        />
                      );
                    })
                  ) : (
                    <div className="lockStats">
                      <p>
                        🔍 "Discover how powerful this Pokémon is! Hit the stats
                        button!"
                      </p>
                    </div>
                  )}
                  {mainDetailsURL?.stats ? (
                    <Stats
                      colorOutcome={colorOutcome}
                      name={"rs"}
                      base={totalStats}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </section>

            <section className="columna-dos">
              <div className="flex-nombre">
                <h2>{mainDetailsURL?.name?.toUpperCase()}.</h2>

                <p>{mainDetailsURL?.name}</p>

                <div id="abilities-container">
                  <div className="elementos-habilities">
                    {/* Verifica si types existe antes de mapear */}
                    {mainDetailsURL?.types?.length > 0 ? (
                      mainDetailsURL.types.map((type, index) => (
                        <ButtonRectangle
                          newColorButton={" #af7ac5 "}
                          key={index}
                          complementaryText={type.type.name}
                        />
                      ))
                    ) : (
                      <p>
                        "Curious about its abilities? Click the button to find
                        out!"🌀
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="container-width-height">
                <DetailsMesures
                  heightPokemon={mainDetailsURL?.height}
                  weigthPokemon={mainDetailsURL?.weight}
                />
                <Ranking baseExperience={mainDetailsURL?.base_experience} />
              </div>

              <div style={{ maxWidth: "90%", padding: "1rem" }}>
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    margin: ".5rem .2rem",
                  }}
                >
                  POKEDEX ENTRY
                </p>
                <div
                  style={{
                    letterSpacing: "0.2px",
                    hyphens: "auto",
                    margin: ".7rem .2rem",
                  }}
                >
                  <p>
                    {detailsSecondaryURL?.flavor_text_entries[0].flavor_text ||
                      "Discover something awesome about this Pokémon!💗 Click the details button to learn more!"}
                  </p>
                </div>
              </div>
              <div className="tres-evoluciones">
                <h3 style={{ margin: "0", fontSize: "1rem" }}>Evolutions:</h3>
                {evolutionData ? (
                  <div className="evolutions-thumbnails">
                    <Thumbnail name={firstEvol} />
                    <Thumbnail name={secondEvol} />
                    <Thumbnail name={thirdEvolution} />
                    {/* {evolutionData.chain?.evolves_to?.map((evo, index) => ( */}
                    {/* <p key={index}> */}
                    {/* <p>
                Evolves to: {evo.species?.name || "Unknown evolution"}
                {firstEvol}
              </p> */}
                    {/* ))} */}

                    {/* <p>{secondEvol}</p> */}
                  </div>
                ) : (
                  <div className="evolutions-thumbnails">
                    <div className="thumbnail">
                      <IconQuestionMark className="iconEvol" />
                    </div>

                    <div className="thumbnail">
                      <IconQuestionMark className="iconEvol" />
                    </div>

                    <div className="thumbnail">
                      <IconQuestionMark className="iconEvol" />
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default FichaTecnicaTableta;
